import { palette, TPalette } from '@shared/tokens/palette.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    backgroundColor: palette['greyWhite'],
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: {
      default: '64px 80px',
      '@media (max-width: 767px)': ' 32px 16px',
    },
    gap: '36px',
    minHeight: '100vh',
  },
  content: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  waitingClockIllustration: {
    width: {
      default: '220px',
      '@media (max-width: 767px)': '160px',
    },
    height: {
      default: '221px',
      '@media (max-width: 767px)': '160px',
    },
    marginBottom: '40px',
    objectFit: 'contain',
  },
  title: {
    color: palette['grey-950'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: '40px',
    fontSize: {
      default: anatomy['size-32'],
      '@media (max-width: 767px)': anatomy['size-24'],
    },
  },
  titleInfo: {
    color: palette['darked-70'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: {
      default: anatomy['size-40'],
      '@media (max-width: 767px)': anatomy['size-36'],
    },
    fontSize: {
      default: anatomy['size-32'],
      '@media (max-width: 767px)': anatomy['size-28'],
    },
  },
  subTitle: {
    color: palette['darked-70'],
    marginTop: '16px',
    fontSize: {
      default: '18px',
      '@media (max-width: 767px)': anatomy['size-16'],
    },
    lineHeight: {
      default: anatomy['size-24'],
      '@media (max-width: 767px)': anatomy['size-20'],
    },
  },
  subTitleInfo: {
    color: palette['grey-950'],
    marginTop: '24px',
    fontSize: {
      default: '28px',
      '@media (max-width: 767px)': anatomy['size-24'],
    },
    lineHeight: {
      default: anatomy['size-36'],
      '@media (max-width: 767px)': anatomy['size-32'],
    },
  },
  subTitleInfoBlocked: {
    color: palette['grey-950'],
    fontSize: {
      default: '28px',
      '@media (max-width: 767px)': anatomy['size-24'],
    },
    lineHeight: {
      default: anatomy['size-36'],
      '@media (max-width: 767px)': anatomy['size-32'],
    },
  },
  infoOrg: {
    color: palette['darked-70'],
    paddingTop: '8px',
    fontSize: {
      default: '16px',
      '@media (max-width: 767px)': '18px',
    },
    lineHeight: {
      default: anatomy['size-24'],
      '@media (max-width: 767px)': anatomy['size-24'],
    },
  },
  date: {
    color: palette['darked-70'],
    fontSize: {
      default: '20px',
      '@media (max-width: 767px)': '18px',
    },
    lineHeight: {
      default: anatomy['size-28'],
      '@media (max-width: 767px)': anatomy['size-24'],
    },
  },
  preloaderContainer: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  categoriesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: anatomy['space-40'],
    gap: anatomy['space-8'],
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    fontWeight: typography.fontWeighDemi,
    maxWidth: '100%',
    userSelect: 'none',
    alignSelf: 'center',
  },
  categoryItem: {
    color: palette['grey-950'],
    flex: '0 0 auto',
    padding: `${anatomy['space-8']} ${anatomy['space-16']}`,
    borderRadius: anatomy.borderRadiusRound,
    border: `1px solid ${palette['darked-40']}`,
  },
  categoryItemColored: (color: keyof TPalette) => ({
    background: palette[color],
    color: palette['greyWhite'],
    border: 'none',
    display: 'flex',
    alignItems: 'center',
  }),
});
